// from Webamp demo

const album = 'Müzik Albümü';

export const initialTracks = [
  {
    url: 'muzikler/music.mp3',
    duration: 322.612245,
    metaData: {
      title: 'Tutamıyorum Zamanı',
      artist: 'Müslüm Gürses',
      album,
    },
  },
];
